import AuthManagerSFC from "./AuthManager.vue";
export type { IAuthManagerEmits } from "./emits";
export const AuthManager = AuthManagerSFC;
